if (!customElements.get('upsell-modal')) {
  customElements.define(
    'upsell-modal',
    class UpsellModal extends DrawerComponent {
      constructor() {
        super();
      }

      connectedCallback() {
        super.connectedCallback();

        this.storageKey = this.dataset.storageKey || 'ino:upsell-modal';
        this.autoOpen = this.dataset.autoOpen === 'true';
        this.delay = parseInt(this.dataset.delay, 10) || 3;
        this.variantId = this.dataset.variantId;

        this.addButton = this.querySelector('[data-upsell-modal-add]');
        if (this.addButton) {
          this.addButton.addEventListener('click', this.onAddToCart.bind(this), {
            signal: this.abortController.signal,
          });
        }

        this.teaser = document.querySelector(`[data-upsell-teaser="${this.id}"]`);
        if (this.teaser) {
          this.teaserStorageKey = `ino:upsell-teaser:${this.dataset.storageKey || this.id}`;
          if (!Shopify.designMode && sessionStorage.getItem(this.teaserStorageKey)) {
            this.teaser.hidden = true;
          }
          const teaserClose = this.teaser.querySelector('[data-upsell-teaser-close]');
          if (teaserClose) {
            teaserClose.addEventListener('click', this.onTeaserClose.bind(this), {
              signal: this.abortController.signal,
            });
          }
        }

        window.FoxTheme.DOMready(this.handleAutoOpen.bind(this));
      }

      onTeaserClose(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.teaser) this.teaser.hidden = true;
        if (Shopify.designMode) return;
        try {
          sessionStorage.setItem(this.teaserStorageKey, '1');
        } catch (e) {
          /* sessionStorage unavailable — dismiss for this view only */
        }
      }

      prepareToShow() {
        super.prepareToShow();
        this.markAsSeen();
      }

      handleAutoOpen() {
        if (Shopify.designMode || !this.autoOpen) return;

        const savedData = FoxTheme.utils.getStorage(this.storageKey);
        if (savedData && savedData.opened) return;

        setTimeout(() => {
          this.show();
        }, this.delay * 1000);
      }

      markAsSeen() {
        if (Shopify.designMode) return;
        FoxTheme.utils.setStorage(this.storageKey, { opened: true }, 365);
      }

      setLoading(state) {
        if (!this.addButton) return;
        if (state) {
          this.addButton.setAttribute('disabled', 'true');
          this.addButton.classList.add('btn--loading');
        } else {
          this.addButton.removeAttribute('disabled');
          this.addButton.classList.remove('btn--loading');
        }
      }

      async onAddToCart(event) {
        event.preventDefault();
        if (!this.variantId || !window.FoxTheme) return;

        this.setLoading(true);

        try {
          const body = JSON.stringify({
            items: [{ id: parseInt(this.variantId, 10), quantity: 1 }],
          });

          const addResponse = await fetch(FoxTheme.routes.cart_add_url, {
            ...FoxTheme.utils.fetchConfig('javascript'),
            body: body,
          });

          const addJson = await addResponse.json();

          if (addJson.status) {
            console.error('Upsell modal add error:', addJson.description || addJson.message);
            return;
          }

          this.hide();
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));

          const cartJson = await (
            await fetch(FoxTheme.routes.cart_url, { ...FoxTheme.utils.fetchConfig() })
          ).json();
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        } catch (err) {
          console.error('Upsell modal add failed:', err);
        } finally {
          this.setLoading(false);
        }
      }
    }
  );
}

// Lip balm template only: the Klaviyo popup is hidden via CSS, but its script still
// locks body scroll when it tries to open. Strip that lock so the page stays scrollable.
(function suppressKlaviyoScrollLock() {
  if (!document.body || !document.body.classList.contains('lip-balm')) return;
  const LOCK = 'klaviyo-prevent-body-scrolling';
  // Only remove when actually present — calling classList.remove() unconditionally
  // re-writes the class attribute and would re-trigger this observer indefinitely.
  const unlock = () => {
    if (document.body.classList.contains(LOCK)) {
      document.body.classList.remove(LOCK);
    }
  };
  unlock();
  new MutationObserver(unlock).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
})();
